import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Select from "@material-ui/core/Select";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React, { Component } from "react";
import Dropdown from "../FormElement/Dropdown";
import { Redirect } from "react-router-dom";
import * as ticketActions from "../../modules/ticket/action";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const styles = theme => ({
  buttonText: {
    "& fieldset": {
      borderColor: "transparent !important",
      borderBottom: "1px solid #ccc !important",
      borderRadius: "0"
    }
  },
  formControl: {
    minWidth: 200
  },
  iconDrop: {
    display: "none"
  },
  mainRoot: {
    padding: "5px 14px"
  },
  menuOption: {
    "& a": {
      // color: 'red',
      textDecoration: "underline"
    }
  }
});

class GroupByDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      SubFarmId: "",
      harvestYearLists: "",
      selectedGroupBy: this.props.groupByValue || "Truckline",
      groupBy:[
        "Truckline",
        "Commodity",
        "External Destination"
   ]
    };
  }
  handleChange = event => {
    const { value } = event.target;
    this.setState({selectedGroupBy:value})
    this.props.actions.setGroupByAction(value)
    // this.props.actions.getCounterPartyTicketList(value);
  };
  render() {
    const { groupBy, selectedGroupBy } = this.state;
    const {
      classes,
      route: { match }
    } = this.props;


    const isDisabled =
      match &&
      (
        match.url === "/app/dashboard" ||
        match.url === "/app" )
        ? true
        : false;
    return (
      <FormControl variant="outlined" className={classes.formControl}>
       {isDisabled &&  
       <div>
          <p className="navDropDownHeading"> View By :</p>
        <Dropdown
          value={selectedGroupBy}
          isClearable={false}
          disabled={false}
          // label={"View By:"}
          handleChange={this.handleChange}
          options={groupBy.map(item => ({
            name: item,
            id: item
          }))}
        />
        </div>}
      </FormControl>
    );
  }
}
function mapStateToProps(state, props) {
  return {
    TicketList: state.ticketReducer.TicketList,
    groupByValue: state.ticketReducer.groupByValue,
    previousDaysvalue: state.ticketReducer.previousDaysvalue
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...ticketActions,
      },
      dispatch
    )
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(GroupByDropdown));



// WEBPACK FOOTER //
// ./src/components/Common/GroupByDropdown.js